module.exports = __webpack_public_path__ + "static/media/workshop4.c856a2e7.jpg";